import React, { Component } from "react";
class ErrorBoundary extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    window.location.href = `../*`;
    return { hasError: true };
  } 

  render() {
    if (this.state.hasError) {
      return (
        <>

          <div   className='container h-100'>
            <div className='row align-items-center h-100'>
              <div className='col-10 col-md-6 offset-lg-6'>
                <div >
                  <h2 style={{ color: "black",fontweight:"50",fontSize:"revert" }}>
                    Um erro ocorreu e o elemento "{this.props.children.type.name}" não pôde ser carregado!
                  </h2>

                </div>

              </div>
            </div>
          </div>
        </>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;